// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: true,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style3',
	},
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);
	boostPFSFilterConfig.general.separateRefineByFromFilter = jQ('.boost-pfs-filter-tree-h').length > 0 ? true : false;

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? 'm-product-card--sold-out' : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, soldOutClass);
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
        // Add Labels
		itemHtml = itemHtml.replace(/{{labels}}/g, buildLabels(data));
        // Add Image
		itemHtml = itemHtml.replace(/{{itemImage}}/g, buildImage(data));
        // Add Hover Image
		itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, buildHoverImage(data));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
        // Add Status
		itemHtml = itemHtml.replace(/{{itemStatus}}/g, buildStatus(data));
        // Add quick buy
		itemHtml = itemHtml.replace(/{{quickAddToCart}}/g, buildQuickbuy(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildQuickbuy(data) {
        var quickbuyHtml = '';
        var klaviyoTrackingHtml = '';
        var disabledAttr = '';

        if(soldOut) {
            disabledAttr = 'disabled'
        }

        var collections = [];
        data.collections.map(function(collection){
            collections.push(collection.title)
        })

        klaviyoTrackingHtml += '<script type="application/json" class="klaviyo-quick-add-tracking">';
        klaviyoTrackingHtml += '{';
        klaviyoTrackingHtml += '"Name": "'+ data.title +'",';
        klaviyoTrackingHtml += '"ProductID": "'+ data.id +'",';
        klaviyoTrackingHtml += '"Categories": '+ JSON.stringify(collections) +',';
        klaviyoTrackingHtml += '"ImageURL": "'+ Utils.optimizeImage(images[0].src, 'grande') +'",';
        klaviyoTrackingHtml += '"URL": "'+ Utils.buildProductItemUrl(data) +'",';
        klaviyoTrackingHtml += '"Brand": "'+ data.vendor +'",';
        klaviyoTrackingHtml += '"Price": "'+ Utils.formatMoney(data.price_min) +'",';
        klaviyoTrackingHtml += '"CompareAtPrice": "'+ Utils.formatMoney(data.compare_at_price_min) +'"';
        klaviyoTrackingHtml += '}';
        klaviyoTrackingHtml += '</script>';

        quickbuyHtml += '<form method="post" action="/cart/add" class="m-product-card__form js-quick-add-to-cart" data-id="'+ getFirstAvailableVariantID(data) +'">';
        quickbuyHtml += '<button type="submit" class="m-product-card__form-btn a-btn a-btn--pink-gray" '+ disabledAttr +'>';
        quickbuyHtml += '<span class="a-btn-text"><svg width="28px" height="21px" viewBox="0 0 28 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Cart" fill="currentColor" fill-rule="nonzero"><path d="M10.8841765,16.5282353 C11.9076176,16.5282353 12.7402059,17.3682353 12.7402059,18.3997058 C12.7402059,19.425 11.9076176,20.265 10.8841765,20.265 C9.8607353,20.265 9.02814706,19.425 9.02814706,18.3997058 C9.02814706,17.3682353 9.8607353,16.5282353 10.8841765,16.5282353 Z M22.0777941,16.5282353 C23.1012353,16.5282353 23.9338235,17.3682353 23.9338235,18.3997058 C23.9338235,19.425 23.1012353,20.265 22.0777941,20.265 C21.0543529,20.265 20.2217647,19.425 20.2217647,18.3997058 C20.2217647,17.3682353 21.0543529,16.5282353 22.0777941,16.5282353 Z M23.2964118,12.6741176 L9.32708824,12.6741176 L7.27155883,4.81764706 L25.1017941,4.83617647 L23.2964118,12.6741176 Z M26.9905588,3.33529412 C26.8151471,3.11294118 26.5489412,2.98941176 26.2666765,2.98323529 L6.78608824,2.96470588 L6.19252942,0.691764706 C6.08567647,0.284117647 5.71755883,-3.55271368e-15 5.29632353,-3.55271368e-15 L0.926470588,-3.55271368e-15 C0.414441177,-3.55271368e-15 0,0.413823529 0,0.926470591 C0,1.43911765 0.414441177,1.85294118 0.926470588,1.85294118 L4.58108824,1.85294118 L5.16970589,4.10117647 C5.17279412,4.11970588 5.1765,4.13205882 5.18020589,4.14441176 L7.71502942,13.8352941 C7.82188236,14.2429411 8.19,14.5270588 8.61185295,14.5270588 L24.0332647,14.5270588 C24.465,14.5270588 24.8392941,14.2305882 24.9362647,13.8105882 L27.1684412,4.11970588 C27.2320588,3.84794118 27.1665882,3.55764706 26.9905588,3.33529412 L26.9905588,3.33529412 Z" id="6G"></path></g></g></svg></span>';
        quickbuyHtml += '<span class="a-btn-bg"></span>';
        quickbuyHtml += '</button>';
        quickbuyHtml += '</form>';
        quickbuyHtml += klaviyoTrackingHtml;
        return quickbuyHtml;
    }

    function getFirstAvailableVariantID(data) {
        var availableVariants = data.variants.filter(function(e) {return e.available === true;})
        return availableVariants.length > 0 ? availableVariants[0].id : data.variants[0].id;
    }

    function buildStatus(data) {
        var statusHtml = '';
        var statusText = '';
        var statusDate = '';
        var currentDate = new Date();
        var allInventory = 0;
        var trackingInventory = false;

        data.variants.forEach(function(variant, index){
            if(variant.inventory_management) {
                trackingInventory = true;
                allInventory = allInventory + variant.inventory_quantity;
            }
        });

        // Low in stock
        if (boostPFSThemeConfig.custom.inventory_settings && allInventory <= boostPFSThemeConfig.custom.inventory_threshold && trackingInventory) {
            statusText = boostPFSThemeConfig.label.status_low_stock;
        }

        // Soldout
        if (soldOut) {
            statusText = boostPFSThemeConfig.label.sold_out;
        }

        data.tags.forEach(function(tag, index){
            // Soon available
            if ( tag.indexOf('__status:soon-available') > -1 ){
                statusText = boostPFSThemeConfig.label.soon_available;
            }

            // Get status date
            if ( tag.indexOf('__status-date:') > -1 ){
                statusDate = tag.split('__status-date:').pop();
            }
        });

        if(statusDate !== '') {
            statusDate = new Date(statusDate);
            var dateDiff = (statusDate - currentDate) / (1000 * 3600 * 24);
            var weekDiff = Math.ceil(dateDiff / 7);

            if (weekDiff === 1) {
                statusText = boostPFSThemeConfig.label.status_bis_single_week.replace(/{{ week }}/, weekDiff);
            } else {
                statusText = boostPFSThemeConfig.label.status_bis_multiple_weeks.replace(/{{ weeks }}/, weekDiff);
            }

            if(dateDiff <= 6) {
                statusText = boostPFSThemeConfig.label.soon_available;
            }
        }

        statusHtml += '<div class="m-product-card__status a-status">';
        statusHtml += '<p>'+ statusText +'</p>';
        statusHtml += '</div>';

        return statusHtml;
    }

    function buildHoverImage(data) {
        var hoverImage = '';
        var hoverImageAlt = '';

        if(images.length === 0) {
            hoverImage = window.theme.productImagePlaceholder;
            hoverImageAlt = data.title;
        } else if(images.length > 1) {
            hoverImage = Utils.optimizeImage(images[1].src, '450x450_crop_center');
            hoverImageAlt = images[1].alt !== null ? images[1].alt : data.title;
        } else {
            hoverImage = Utils.optimizeImage(images[0].src, '450x450_crop_center');
            hoverImageAlt = images[0].alt !== null ? images[0].alt : data.title;
        }

        return '<img class="lazyload" alt="'+ hoverImageAlt +'" data-src="'+ hoverImage +'"/>';
    }

    function buildImage(data) {
        var image = '';
        var imageAlt = '';

        if(images.length === 0) {
            image = window.theme.productImagePlaceholder;
            imageAlt = data.title;
        } else {
            image = Utils.optimizeImage(images[0].src, '450x450_crop_center');
            imageAlt = images[0].alt !== null ? images[0].alt : data.title;
        }

        return '<img class="m-product-card__image lazyload" alt="'+ imageAlt +'" data-src="'+ image +'"/>';
    }

    function buildLabels(data) {
        var labelHtml = '';
        labelHtml += '<div class="m-product-card__labels">';
        if(data.compare_at_price_min > data.price_min) {
            labelHtml += '<div class="m-product-card__label a-label a-label--yellow">'+ boostPFSThemeConfig.label.product_label_sale +'</div>';
        } else {
            data.tags.forEach(function(tag, index){
                if ( tag.indexOf('__label:new') > -1 ){
                    labelHtml += '<div class="m-product-card__label a-label">'+ boostPFSThemeConfig.label.product_label_new +'</div>';
                }
            });
        }
        labelHtml += '</div>';
        return labelHtml;
    }


	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 1 / aspectRatio * 100;

			html += '<div';
			if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
				boostPFSThemeConfig.custom.add_image_padding === true) {
				html += ' class="card__media-full-spacer"';
			}
			html += '>';
			html += '<div class="media media--transparent media--';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media--hover-effect"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
				boostPFSThemeConfig.custom.media_size == 'adapt' &&
				images.length > 0) {
				html += ' style="padding-bottom: ' + paddingBottom + '%"';
			}
			html += '>'
			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + flipImageSrcSet + '" ' +
				'height="' + images[1].height + '" ' +
				'width="' + images[1].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			}
			html += '</div>';
			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'm-product-card--sold-out';
		}
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ('.collection-filters__sort').change(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

    // Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
        var productCountHTML = '';
		// var totalProduct = '';
		if (data.total_product == 1) {
            productCountHTML = boostPFSConfig.label.product_count_one.replace(/{{ count }}/g, data.total_product);
        } else {
            productCountHTML = boostPFSConfig.label.product_count.replace(/{{ count }}/g, data.total_product);
        }
        jQ('.boost-pfs-filter-total-product').html(productCountHTML);

        var whatSubInterval = setInterval(function() {
            if(window.WhatSub !== undefined) {
                window.WhatSub.dispatch('AFTER_FILTER_RENDER');
                clearInterval(whatSubInterval);
            }
        }, 300);
	};

	/************************** END BUILD TOOLBAR **************************/

  	ProductPaginationDefault.prototype._onClickEvent = function(event) {
		event.preventDefault();
		Globals.internalClick = true;

		// Get the new page value
		var url;
		try {
			url = new URL(jQ(event.currentTarget).attr('href'));
		} catch (e) {
			url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
		}

		var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
		if (!pageValue) pageValue = 1;

		// Apply filter
		FilterApi.setParam('page', pageValue);
		FilterApi.applyFilter('page');

		// Scroll to top of product list
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}
})();
